/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Chaitanya
*/

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';
import { View, StyleSheet, Dimensions } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import SelectBox from '@components/form/SelectBox';
import * as Layout from '@components/screen/Layout';
import TaxesForm from '@components/setting/coa-tax/TaxesForm';
import { SociollaSelectBox } from '@components/sociolla/form';
import ScrollContainer from '@components/global/ScrollContainer';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import { YES_NO_STATUS, COA_TAX_SKP_FLOW_TYPE } from '@/constants';
import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';

const { height: windowHeight } = Dimensions.get('window');
const TaxSchema = Yup.object().shape({
  tax_value: Yup.string().when('is_deleted', {
    is: (is_deleted) => is_deleted,
    then: Yup.string().nullable(),
    otherwise: Yup.string().required('Tax Value is required'),
  }),
  cerebro_id: Yup.string().when('is_deleted', {
    is: (is_deleted) => is_deleted,
    then: Yup.string().nullable(),
    otherwise: Yup.string().required('Cerebro ID is required'),
  }),
});

const FormValidationSchema = Yup.object().shape({
  cost_type: Yup.string().required('Cost Type is required.'),
  coa_number: Yup.string().required('COA number is required.'),
  description: Yup.string().required('description is required.'),
  coa_cerebro_id: Yup.number().required('COA Cerebro id is required.'),
  is_waiting_for_sales_realization: Yup.boolean().required(
    'waiting for sales realization is required.',
  ),
  tax_corporate: Yup.array().of(TaxSchema),
  tax_personal: Yup.array().of(TaxSchema),
  vat: Yup.array().of(TaxSchema),
});

const CoaTaxSettingFormScreen = (props) => {
  const dispatch = useDispatch();
  const [detailData, setDetailData] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const getCoaTaxSettingsDetail = useApi(MsOrder.getCoaTaxSettingsDetail);

  const getDetail = async (id) => {
    const response = await getCoaTaxSettingsDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;

      result.is_active = result.is_active
        ? { label: 'Active', value: true }
        : { label: 'In Active', value: false };

      result.skp_type_flow = result.skp_type_flow || '';

      setDetailData(result);
    }
  };

  const goBack = () => {
    if (isEdit) {
      props.navigation.navigate('CoaTaxSettingDetailScreen', {
        id: detailData._id,
        titleScreen: detailData.cost_type,
        cost_type: detailData.cost_type,
      });
    } else {
      props.navigation.navigate('CoaTaxSettingScreen');
    }
  };

  const handleSubmitCoaTax = async (payload) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const finalPayload = {
        cost_type: payload.cost_type,
        description: payload.description,
        coa_number: payload.coa_number,
        is_waiting_for_sales_realization:
          payload.is_waiting_for_sales_realization,
        coa_cerebro_id: payload.coa_cerebro_id,
        ppn: payload.ppn,
        ppn_cerebro_id: payload.ppn_cerebro_id,

        pph_npwp_badan: payload.pph_npwp_badan,
        pph_npwp_badan_cerebro_id: payload.pph_npwp_badan_cerebro_id,
        pph_npwp_pribadi: payload.pph_npwp_pribadi,
        pph_npwp_pribadi_cerebro_id: payload.pph_npwp_pribadi_cerebro_id,
        pph_non_npwp_badan: payload.pph_non_npwp_badan,
        pph_non_npwp_badan_cerebro_id: payload.pph_non_npwp_badan_cerebro_id,
        pph_non_npwp_pribadi: payload.pph_non_npwp_pribadi,
        pph_non_npwp_pribadi_cerebro_id:
          payload.pph_non_npwp_pribadi_cerebro_id,

        tax_corporate: payload.tax_corporate,
        tax_personal: payload.tax_personal,
        non_tax_corporate: payload.non_tax_corporate,
        non_tax_personal: payload.non_tax_personal,
        vat: payload.vat,

        is_active: payload.is_active.value,
        skp_type_flow: payload.skp_type_flow,
      };

      const nonDeletedTaxCorporate = (finalPayload.tax_corporate || []).filter(
        (t) => !t.is_deleted,
      );
      if (nonDeletedTaxCorporate.length) {
        const taxCorporate = nonDeletedTaxCorporate.filter((t) => t.is_default);
        if (taxCorporate.length != 1) {
          Toast.show({
            text1: 'Tax ID Corporate need to have 1 default',
            type: 'error',
          });
          dispatch(showPopup({ name: 'isLoading', value: false }));
          return;
        }
        finalPayload.pph_npwp_badan = null;
        finalPayload.pph_npwp_badan_cerebro_id = null;
      }
      const nonDeletedTaxPersonal = (finalPayload.tax_personal || []).filter(
        (t) => !t.is_deleted,
      );
      if (nonDeletedTaxPersonal.length) {
        const taxPersonal = nonDeletedTaxPersonal.filter((t) => t.is_default);
        if (taxPersonal.length != 1) {
          Toast.show({
            text1: 'Tax ID Personal need to have 1 default',
            type: 'error',
          });
          dispatch(showPopup({ name: 'isLoading', value: false }));
          return;
        }
        finalPayload.pph_npwp_pribadi = null;
        finalPayload.pph_npwp_pribadi_cerebro_id = null;
      }
      const nonDeletedVat = (finalPayload.vat || []).filter(
        (t) => !t.is_deleted,
      );
      if (nonDeletedVat.length) {
        const vat = nonDeletedVat.filter((t) => t.is_default);
        if (vat.length != 1) {
          Toast.show({
            text1: 'VAT need to have 1 default',
            type: 'error',
          });
          dispatch(showPopup({ name: 'isLoading', value: false }));
          return;
        }
      }

      if (!isEdit) {
        const createData = await MsOrder.createCoaTaxSettings(finalPayload);
        if (createData?.data?.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Successfully added data',
            type: 'success',
          });
          props.navigation.navigate('CoaTaxSettingDetailScreen', {
            id: createData?.data?.data?._id,
            name: createData?.data?.data?.cost_type,
            titleScreen: createData?.data?.data?.cost_type,
          });
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'A system error occurred',
            type: 'error',
          });
        }
      } else {
        const updateData = await MsOrder.updateCoaTaxSettings(
          detailData._id,
          finalPayload,
        );
        if (updateData?.data?.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Successfully edited data',
            type: 'success',
          });
          props.navigation.navigate('CoaTaxSettingDetailScreen', {
            id: updateData?.data?.data?._id,
            name: updateData?.data?.data?.cost_type,
            titleScreen: updateData?.data?.data?.cost_type,
          });
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'A system error occurred',
            type: 'error',
          });
        }
      }
      dispatch(showPopup({ name: 'isLoading', value: false }));
    } catch (error) {
      console.log(error);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setIsEdit(false);
      setDetailData({});
      if (props?.route?.params?.id) {
        setIsEdit(true);
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const formatSkpFlowValue = (val) => {
    const skpFlowMap = COA_TAX_SKP_FLOW_TYPE.reduce((acc, item) => {
      acc[item.value] = item;
      return acc;
    }, {});
    return skpFlowMap[val] || '';
  };

  return (
    <Layout.Container>
      {isEdit && getCoaTaxSettingsDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (isEdit ? detailData && Object.keys(detailData).length : true) ? (
        <Formik
          initialValues={{
            cost_type:
              isEdit && detailData?.cost_type ? detailData.cost_type : '',
            coa_number:
              isEdit && detailData?.coa_number ? detailData.coa_number : '',
            description:
              isEdit && detailData?.description ? detailData.description : '',
            is_waiting_for_sales_realization:
              isEdit && detailData?.is_waiting_for_sales_realization
                ? detailData.is_waiting_for_sales_realization
                : false,
            pph_npwp_badan:
              isEdit && detailData?.pph_npwp_badan
                ? detailData.pph_npwp_badan
                : '',
            pph_non_npwp_pribadi:
              isEdit && detailData?.pph_non_npwp_pribadi
                ? detailData.pph_non_npwp_pribadi
                : '',
            pph_npwp_pribadi:
              isEdit && detailData?.pph_npwp_pribadi
                ? detailData.pph_npwp_pribadi
                : '',
            pph_non_npwp_badan:
              isEdit && detailData?.pph_non_npwp_badan
                ? detailData.pph_non_npwp_badan
                : '',
            ppn: isEdit && detailData?.ppn ? detailData.ppn : '',
            coa_cerebro_id:
              isEdit && detailData?.coa_cerebro_id
                ? detailData.coa_cerebro_id
                : '',
            pph_npwp_badan_cerebro_id:
              isEdit && detailData?.pph_npwp_badan_cerebro_id
                ? detailData.pph_npwp_badan_cerebro_id
                : '',
            pph_non_npwp_badan_cerebro_id:
              isEdit && detailData?.pph_non_npwp_badan_cerebro_id
                ? detailData.pph_non_npwp_badan_cerebro_id
                : '',
            pph_npwp_pribadi_cerebro_id:
              isEdit && detailData?.pph_npwp_pribadi_cerebro_id
                ? detailData.pph_npwp_pribadi_cerebro_id
                : '',
            pph_non_npwp_pribadi_cerebro_id:
              isEdit && detailData?.pph_non_npwp_pribadi_cerebro_id
                ? detailData.pph_non_npwp_pribadi_cerebro_id
                : '',
            ppn_cerebro_id:
              isEdit && detailData?.ppn_cerebro_id
                ? detailData.ppn_cerebro_id
                : '',
            tax_corporate:
              isEdit && detailData?.tax_corporate
                ? detailData.tax_corporate
                : [],
            tax_personal:
              isEdit && detailData?.tax_personal ? detailData.tax_personal : [],
            non_tax_corporate:
              isEdit && detailData?.non_tax_corporate
                ? detailData.non_tax_corporate
                : [],
            non_tax_personal:
              isEdit && detailData?.non_tax_personal
                ? detailData.non_tax_personal
                : [],
            vat: isEdit && detailData?.vat ? detailData.vat : [],
            is_active: isEdit ? detailData?.is_active : '',
            skp_type_flow: isEdit ? detailData?.skp_type_flow : '',
          }}
          validationSchema={FormValidationSchema}
          onSubmit={handleSubmitCoaTax}>
          {({ setFieldValue, handleSubmit, errors, touched, values }) => (
            <>
              {isWeb && (
                <Layout.Wrapper white={false}>
                  <Layout.Back
                    title="COA Tax Setting"
                    onCallback={() => goBack()}
                  />
                  <Layout.Title
                    title={`${isEdit ? `Edit` : `Add`} COA Tax Setting`}>
                    <View style={styles.row}>
                      <Button
                        type="primary"
                        rounded
                        buttonStyle={{ width: 120 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            {isEdit ? 'SAVE' : 'ADD'}
                          </SociollaText>
                        }
                        onPress={handleSubmit}
                      />
                    </View>
                  </Layout.Title>
                </Layout.Wrapper>
              )}

              <Layout.Wrapper rounded bottomSpace={!isWeb ? 70 : 0} isHeight>
                <ScrollContainer
                  style={{
                    ...(isWeb ? {} : { height: windowHeight * 0.92 }),
                  }}>
                  <Layout.FormWrapper style={styles.formWrapper}>
                    <View style={styles.rowForm}>
                      <Layout.FormGroup>
                        <Input
                          label="Cost Type"
                          value={values.cost_type}
                          isRequired
                          placeholder="Cost Type"
                          hasError={
                            errors.cost_type && touched.cost_type
                              ? errors.cost_type
                              : null
                          }
                          onChangeText={(val) => {
                            setFieldValue('cost_type', val);
                          }}
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <View style={{ flexDirection: 'row' }}>
                          <Input
                            label="COA Number"
                            value={values.coa_number}
                            isRequired
                            placeholder="COA Number"
                            hasError={
                              errors.coa_number && touched.coa_number
                                ? errors.coa_number
                                : null
                            }
                            onChangeText={(val) => {
                              setFieldValue('coa_number', val);
                            }}
                            inputContainerStyle={{ width: '98%' }}
                            containerStyle={{ width: '50%' }}
                          />
                          <Input
                            label="COA ID Cerebro"
                            value={values.coa_cerebro_id}
                            isRequired
                            placeholder="COA ID Cerebro"
                            hasError={
                              errors.coa_cerebro_id && touched.coa_cerebro_id
                                ? errors.coa_cerebro_id
                                : null
                            }
                            onChangeText={(val) => {
                              setFieldValue('coa_cerebro_id', val);
                            }}
                            inputContainerStyle={{ width: '100%' }}
                            containerStyle={{ width: '50%' }}
                          />
                        </View>
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <Input
                          label="Description"
                          value={values.description}
                          isRequired
                          placeholder="Description"
                          hasError={
                            errors.description && touched.description
                              ? errors.description
                              : null
                          }
                          onChangeText={(val) => {
                            setFieldValue('description', val);
                          }}
                        />
                      </Layout.FormGroup>
                    </View>
                    <View style={styles.rowForm}>
                      <Layout.FormGroup>
                        <SelectBox
                          label="Define SKP External Flow"
                          options={COA_TAX_SKP_FLOW_TYPE}
                          value={formatSkpFlowValue(values.skp_type_flow)}
                          placeholder="Define SKP External Flow"
                          trackBy="value"
                          labelKey="label"
                          isRequired
                          hasError={
                            errors.skp_type_flow && touched.skp_type_flow
                              ? errors.skp_type_flow
                              : null
                          }
                          onChange={(value) => {
                            setFieldValue('skp_type_flow', value.value);
                          }}
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <SelectBox
                          label="Waiting for Sales Realization"
                          options={YES_NO_STATUS}
                          value={
                            values.is_waiting_for_sales_realization
                              ? YES_NO_STATUS[0]
                              : YES_NO_STATUS[1]
                          }
                          placeholder="Select waiting For Sales Realization"
                          trackBy="value"
                          labelKey="name"
                          isRequired
                          hasError={
                            errors.is_waiting_for_sales_realization &&
                            touched.is_waiting_for_sales_realization
                              ? errors.is_waiting_for_sales_realization
                              : null
                          }
                          onChange={(value) => {
                            setFieldValue(
                              'is_waiting_for_sales_realization',
                              value.value,
                            );
                          }}
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <SociollaSelectBox
                          isTransparent={true}
                          label="Active/Inactive"
                          options={[
                            {
                              label: 'Active',
                              value: true,
                            },
                            {
                              label: 'In Active',
                              value: false,
                            },
                          ]}
                          name="is_active"
                          trackBy="value"
                          labelKey="label"
                          isRequired
                          value={values.is_active}
                          onChange={(val) => {
                            setFieldValue('is_active', val);
                          }}
                        />
                      </Layout.FormGroup>
                    </View>
                  </Layout.FormWrapper>

                  <TaxesForm
                    title={'Tax ID Corporate'}
                    setFieldValue={setFieldValue}
                    values={values}
                    id={'tax_corporate'}
                    errors={errors}
                    isEdit={true}
                  />
                  <TaxesForm
                    title={'Tax ID Personal'}
                    setFieldValue={setFieldValue}
                    values={values}
                    id={'tax_personal'}
                    errors={errors}
                    isEdit={true}
                  />
                  <TaxesForm
                    title={'VAT'}
                    setFieldValue={setFieldValue}
                    values={values}
                    id={'vat'}
                    errors={errors}
                    isEdit={true}
                  />
                </ScrollContainer>
              </Layout.Wrapper>
            </>
          )}
        </Formik>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row' },
  rowForm: { width: isWeb ? 'calc(50% - 20px)' : '100%' },
  formWrapper: {
    paddingHorizontal: 15,
    paddingTop: 20,
    ...(isWeb
      ? {
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingHorizontal: 20,
          marginBottom: 15,
        }
      : {
          paddingBottom: 20,
        }),
  },
});

export default CoaTaxSettingFormScreen;
